const Pricing = () => {

    const plans = [
        {   plan: "Plan Mensual",
            desc: "Incluye: Instalación, Dominio, Hosting y SSL ",
            price: "3,500",
            promotion: "1,500", 
            isMostPop: true,
            features: [
                "Rifas Ilimitadas al Mes",
                "Multiples Líneas de Sorteos",
                "Boleto Digital",
                "Verificador de Boletos",
                "Panel de Control",
                "Y más..."
            ],
        },
        
    ];

    return (
        <section className='py-14 '>
            <div className="max-w-screen-xl mx-auto text-text dark:text-darktext sm:px-4 md:px-8">
                <div className='max-w-xl mx-auto space-y-3 px-4 sm:text-center sm:px-0'>
                  
                    <p className='sm:text-4xl text-3xl text-center font-semibold'>
                        Costo
                    </p>
                </div>
                <div className='mt-4 p-2 justify-center sm:flex'>
                    {
                        plans.map((item, idx) => (
                            <div key={idx} className={`flex-1 flex items-stretch flex-col mt-6 border-2 sm:mt-0 sm:rounded-xl sm:max-w-md ${item.isMostPop ? "bg-pagebackground dark:bg-darkpagebackground border-accent dark:border-darkaccent sm:border-x-2" : "border-transparent"}`}>
                                
                                <div className="p-4 py-8 space-y-4 border-b border-gray-700 md:p-8">
                                <p className="text-center text-2xl font-semibold mb-4">{item.plan}</p>
                                    {item.promotion && (
                                        <div className="text-center bg-yellow-400 text-yellow-900 font-bold py-2 rounded-lg">
                                            ¡Promoción del primer mes a ${item.promotion} MXN!
                                        </div>
                                    )}
                                    <div className='text-green-600 dark:text-darkaccent text-3xl text-center font-bold'>
                                        ${item.price} MXN<span className="text-xl font-bold">/mes</span>
                                    </div>
                                    <p className="text-gray-600 dark:text-gray-400">
                                        {item.desc}
                                    </p>
                                    
                                </div>
                                <ul className='p-4 py-8 space-y-3 md:p-8'>
                                    {
                                        item.features.map((featureItem, idx) => (
                                            <li key={idx} className='flex items-center gap-5'>
                                                <svg
                                                    xmlns='http://www.w3.org/2000/svg'
                                                    className={`h-5 w-5 ${item.isMostPop ? "text-accent" : ""}`}
                                                    viewBox='0 0 20 20'
                                                    fill='currentColor'>
                                                    <path
                                                        fillRule='evenodd'
                                                        d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                                                        clipRule='evenodd'></path>
                                                </svg>
                                                {featureItem}
                                            </li>
                                        ))
                                    }
                                </ul>
                            </div>
                        ))
                    }
                </div>
            </div>
        </section>
    );
};

export default Pricing;
